import * as React from "react";
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { FixedCommentSetForm } from "../FixedCommentsForm/FixedCommentsForm";
import { FixedCommentSetFormModel, GetModelFromFormState } from "../Types";
import { useNavigate, Link } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";
import { FormState } from "informedv4";

const CreateFixedCommentSetScreen = ({ }): JSX.Element => {

    const [isBusy, setIsBusy] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string>();
    const [successAlert, setSuccessAlert] = React.useState(false);

    const client = useWebPortalApiClient();

    const navigate = useNavigate();
    const { study } = useCurrentStudyConfigurationContext();

    const onSubmit = async(values: FormState) => {
        setIsBusy(true);
        setSuccessAlert(false);
        setError(null);

        try {
            const studySets = await client.client.getStudyFixedCommentSets(undefined, `studyId eq ${study.id} and sessionType eq '${(values.values as unknown as FixedCommentSetFormModel).SessionType}' and commentSetType eq '${(values.values as unknown as FixedCommentSetFormModel).SetType}'`);
            const model = GetModelFromFormState(values.values as unknown as FixedCommentSetFormModel, study.id);

            let studySetId;
            if (studySets.value.length === 0) {
                const postResult = await client.client.postStudyFixedCommentSet({ ...model, fixedCommentSets: undefined });
                studySetId = postResult.id;
            } else {
                studySetId = studySets.value[0].id;
            }

            await client.client.postFixedCommentSet({ ...model.fixedCommentSets[0], studySetId: studySetId });

            setIsBusy(false);
            setSuccessAlert(true);
        } catch (e) {
            setError(e.message);
            setIsBusy(false);
        }
    };

    const initialCommentsFormValues: FixedCommentSetFormModel = {
        EntityType: null,
        SessionType: null,
        SetType: null,
        Comments: {},
        DefaultSelectedComment: null,
        Id: null
    };

    return (
        <>
            <Alert show={successAlert} category={AlertCategoryEnum.Success}>
                Saved successfully. Return to{" "}
                <Link to={`/FixedComments`}>Fixed Comments list</Link>?
            </Alert>
            <FixedCommentSetForm
                editMode={false}
                initialCommentsFormValues={initialCommentsFormValues}
                onSubmit={onSubmit}
                title="Create New Fixed Comments Set"
                error={error}
            />
        </>
    );
};


export default CreateFixedCommentSetScreen;
